import store from './store';

export default options => {
  const { meta, data } = options;
  const {
    subject,
    course,
    businessConfigUuid,
    contentSelectedKey,
    targetCatalogUuid,
  } = nx.hashlize();
  const url = meta.url;

  if (url.includes(`/api/v1/business_catalogue_${subject}/${businessConfigUuid}?pageNo=1`)) {
    store.set('businessConfigName', nx.get(data, 'businessConfigName'));
  }

  if (
    url.endsWith(`/api/v1/business_content_${subject}/${businessConfigUuid}/${contentSelectedKey}`)
  ) {
    // https://redmine.saybot.net/issues/131677
    const businessType = nx.get(data, 'businessType');
    const displayName = businessType === 'VIDEO' ? '看视频' : nx.get(data, 'templateName');
    store.set('templateName', displayName);
  }

  if (
    url.includes(
      `/api/v1/businesses_${subject}/${businessConfigUuid}/collection?businessClassificationUuid`
    )
  ) {
    store.set('businessConfigName', nx.get(data, 'businessConfigName'));
  }

  if (
    url.includes(`/api/v2/businesses_${subject}/task_business_within_course`) ||
    url.includes(`/api/v1/businesses_${subject}/collection?businessConfigUuid`) ||
    url.endsWith(`/api/v1/course_catalogue_${subject}?courseUuid=${course}`)
  ) {
    store.set('name', nx.get(data, 'cnName', nx.get(data, 'courseName')));
    const courseCatalogues = nx.get(
      data,
      'courseCatalogues',
      nx.get(data, 'courseCatalogueResponses', [])
    );
    const treeData = new nx.Tree(courseCatalogues);
    const unit = treeData.find((key, item) => item.uuid === targetCatalogUuid);
    store.set('unitTitle', nx.get(unit, 'title'));

    if ('AI_INTERACTIVE_CLASS' === businessConfigUuid) {
      store.set('unitTitle', 'AI课件');
    }
  }

  if (url.endsWith(`/api/v1/course_catalogue_${subject}/listAll?courseUuid=${course}`)) {
    store.set('cnName', nx.get(data, 'cnName'));
    store.set('courseSeriesCnName', nx.get(data, 'courseSeriesCnName'));
  }

  if (url.includes(`/api/v1/businesses_${subject}/${businessConfigUuid}/business_contents`)) {
    store.set('businessCatalogueName', nx.get(data, 'businessCatalogueName'));
  }

  return options;
};
